// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var CommissionTypes;
(function (CommissionTypes) {
    CommissionTypes[CommissionTypes["PerLot"] = 0] = "PerLot";
    CommissionTypes[CommissionTypes["PerFill"] = 1] = "PerFill";
    CommissionTypes[CommissionTypes["PerTransaction"] = 2] = "PerTransaction";
    CommissionTypes[CommissionTypes["PerPhoneTransaction"] = 3] = "PerPhoneTransaction";
    CommissionTypes[CommissionTypes["VAT"] = 4] = "VAT";
    CommissionTypes[CommissionTypes["PerVolume"] = 5] = "PerVolume";
    CommissionTypes[CommissionTypes["PerOrderVolume"] = 6] = "PerOrderVolume";
    CommissionTypes[CommissionTypes["VolumeWithMinPD"] = 7] = "VolumeWithMinPD";
    CommissionTypes[CommissionTypes["OrderPerLot"] = 8] = "OrderPerLot";
    CommissionTypes[CommissionTypes["TotalFee"] = 9] = "TotalFee";
    CommissionTypes[CommissionTypes["OptionExercise"] = 10] = "OptionExercise";
    CommissionTypes[CommissionTypes["CareOrder"] = 11] = "CareOrder";
    CommissionTypes[CommissionTypes["OrderPerLotWithFixedPart"] = 12] = "OrderPerLotWithFixedPart";
    CommissionTypes[CommissionTypes["FillFaceValue"] = 13] = "FillFaceValue";
    CommissionTypes[CommissionTypes["SwapBuy"] = 14] = "SwapBuy";
    CommissionTypes[CommissionTypes["SwapSell"] = 15] = "SwapSell";
    CommissionTypes[CommissionTypes["ShortCommissionInfo"] = 16] = "ShortCommissionInfo";
    CommissionTypes[CommissionTypes["CustodialFee"] = 17] = "CustodialFee";
    CommissionTypes[CommissionTypes["ShortPositionInterest"] = 18] = "ShortPositionInterest";
})(CommissionTypes || (CommissionTypes = {}));
export var CommissionOperationType;
(function (CommissionOperationType) {
    // значения используются в ключах локализации для InstrumentDetails - имя не менять
    CommissionOperationType[CommissionOperationType["ALL"] = 0] = "ALL";
    CommissionOperationType[CommissionOperationType["BUY"] = 1] = "BUY";
    CommissionOperationType[CommissionOperationType["SHORT"] = 2] = "SHORT";
    CommissionOperationType[CommissionOperationType["SELL"] = 3] = "SELL";
    CommissionOperationType[CommissionOperationType["OPEN"] = 4] = "OPEN";
    CommissionOperationType[CommissionOperationType["CLOSE"] = 5] = "CLOSE";
    CommissionOperationType[CommissionOperationType["OPENBUY"] = 6] = "OPENBUY";
    CommissionOperationType[CommissionOperationType["OPENSELL"] = 7] = "OPENSELL";
    CommissionOperationType[CommissionOperationType["OPENSHORT"] = 8] = "OPENSHORT";
    CommissionOperationType[CommissionOperationType["CLOSEBUY"] = 9] = "CLOSEBUY";
    CommissionOperationType[CommissionOperationType["CLOSESELL"] = 10] = "CLOSESELL";
})(CommissionOperationType || (CommissionOperationType = {}));
export var CommissionPaymentType;
(function (CommissionPaymentType) {
    CommissionPaymentType[CommissionPaymentType["Absolute"] = 0] = "Absolute";
    CommissionPaymentType[CommissionPaymentType["VolumePercent"] = 1] = "VolumePercent";
})(CommissionPaymentType || (CommissionPaymentType = {}));
export var FeeStringVariable;
(function (FeeStringVariable) {
    FeeStringVariable[FeeStringVariable["Amount"] = 0] = "Amount";
    FeeStringVariable[FeeStringVariable["Price"] = 1] = "Price";
})(FeeStringVariable || (FeeStringVariable = {}));
